import { createFileRoute } from '@tanstack/react-router'
import { requireCompleteProfile } from '@/lib/auth-guard'
import DashboardPage from '@/pages/Dashboard'

export const Route = createFileRoute('/dashboard')({
  ...requireCompleteProfile(),
  component: DashboardPage,
})